import React, { useCallback, useState } from "react";
import { Button, Dropdown, Menu } from "antd";
import { DashOutlined, PaperClipOutlined } from "@ant-design/icons";
import { InvoiceDocument } from "../../../../models/DepartmentData/InvoiceDocument";
import { StoreWithDownloadInvoice } from "../download-invoice-link/DownloadInvoiceLink";
import { GetterFn } from "../../../../models/Get";

type Props = {
  documents: InvoiceDocument[];
  invoiceKey: number;
  store:
    | StoreWithDownloadInvoice
    | GetterFn<StoreWithDownloadInvoice, true>
    | GetterFn<StoreWithDownloadInvoice>;
};

const InvoiceDocumentsList: React.FC<Props> = ({
  documents,
  invoiceKey,
  store,
}) => {
  const [loadingType, setLoadingType] = useState<string | null>(null);

  const download = useCallback(
    async (doc: InvoiceDocument) => {
      setLoadingType(doc.type);
      let storeInstance: StoreWithDownloadInvoice | null = null;
      if (typeof store === "function") {
        storeInstance = await store();
      } else {
        storeInstance = store;
      }
      await storeInstance.downloadInvoice(invoiceKey, doc.filename, doc.type);
      setLoadingType(null);
    },
    [invoiceKey, store]
  );

  if (!documents || documents.length === 0) {
    return <></>;
  }

  const visible = documents.slice(0, 2);
  const overflow = documents.slice(2);
  const hasOverflow = overflow.length > 0;

  const dropdownMenu = (
    <Menu>
      {overflow.map((doc) => (
        <Menu.Item key={doc.type} onClick={() => download(doc)}>
          <div className="download-link">
            {doc.filename}
            <PaperClipOutlined />
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="upload-files-wrapper">
      <div className="download-files">
        {visible.map((doc) => (
          <div key={doc.type}>
            <Button
              type="link"
              loading={loadingType === doc.type}
              disabled={loadingType !== null}
              className="file-wrapper"
              style={{ color: "black" }}
              onClick={() => download(doc)}
            >
              <div className="download-link">
                {doc.filename}
                <PaperClipOutlined />
              </div>
            </Button>
          </div>
        ))}
      </div>
      {hasOverflow && (
        <div className="upload-files-container">
          <Dropdown overlay={dropdownMenu}>
            <Button type="primary" style={{ minWidth: "25px" }}>
              <DashOutlined />
            </Button>
          </Dropdown>
        </div>
      )}
    </div>
  );
};

export default InvoiceDocumentsList;
